mutation AddEditableDerestriction($campaignId: ID!, $editableId: ID!) {
    addEditableDerestriction(editableId: $editableId, campaignId: $campaignId) {
        _id
        name
        restricted
    }
}
